import React from 'react'

export const ShipmentFulfillmentDocumentDetailContext = React.createContext(null);
export const useShipmentFulfillmentDocumentDetailContext = () => {

    const context = React.useContext(ShipmentFulfillmentDocumentDetailContext);

    if (!context) throw new Error("ShipmentFulfillmentDocument Detail Context not provided!");

    return context;
}
